<template>
    <div
        v-if="file?.expiryDiary?.linked"
        class="form-col"
    >
        <p>This document has a company diary expiry entry.</p>
        <div
            v-if="canModify"
            class="flex items-center gap-2"
        >
            <MuvalCheckbox
                v-model="cancel"
                label="Delete its expiry entry and stop pending reminders"
            />
        </div>
        <p
            v-else
            class="text-muval-gray-2 text-sm"
        >
            The diary entry and its reminders will remain unless a diary editor deletes them first.
        </p>
    </div>
</template>
<script setup lang="ts">
import MuvalCheckbox from '@inputs/MuvalCheckbox.vue';
import { useCompanyDiaryPermissions } from '@composables/useCompanyDiaryPermissions';
defineProps<{ file: any }>();
const cancel = defineModel<boolean>({ default: false });
const { canModify } = useCompanyDiaryPermissions();
</script>
